<div class="container mt-4">
    <h3 class="mt-2 mb-4 d-flex justify-content-center">{{ "survey.show.report.attachment" | translate }}</h3>

    <div class="w-100 d-flex justify-content-center mt-4">
        <table class="table table-hover">
            <tbody>
                <tr>
                    <td>
                        <button #questionnaireRef class="btn w-100 text-start" (click)="doDownloadQuestionnaire(questionnaireRef)" [disabled]="downloading">
                            <span class="me-2" style="color: Tomato;">
                                <fa-icon [icon]="['fas', 'file-pdf']" size="xl"></fa-icon>
                            </span>
                            <span>{{ "survey.show.report.questionnaire" | translate }}</span>
                        </button>
                    </td>
                </tr>

                <tr *ngIf="isSavingsReport">
                    <td>
                        <button #savingsRef class="btn w-100 text-start" (click)="doDownloadSaving(savingsRef)" [disabled]="downloading">
                            <span class="me-2" style="color: Tomato;">
                                <fa-icon [icon]="['fas', 'file-pdf']" size="xl"></fa-icon>
                            </span>
                            <span>{{ "survey.show.report.savings" | translate }}</span>
                        </button>
                    </td>
                </tr>

                <tr *ngIf="isPrevidenceReport">
                    <td>
                        <button #previdenceRef class="btn w-100 text-start" (click)="doDownloadPrevidence(previdenceRef)" [disabled]="downloading">
                            <span class="me-2" style="color: Tomato;">
                                <fa-icon [icon]="['fas', 'file-pdf']" size="xl"></fa-icon>
                            </span>
                            <span>{{ "survey.show.report.previdence" | translate }}</span>
                        </button>
                    </td>
                </tr>

                <tr *ngIf="isProtectionReport">
                    <td>
                        <button #protectionRef class="btn w-100 text-start" (click)="doDownloadProtection(protectionRef)" [disabled]="downloading">
                            <span class="me-2" style="color: Tomato;">
                                <fa-icon [icon]="['fas', 'file-pdf']" size="xl"></fa-icon>
                            </span>
                            <span>{{ "survey.show.report.protection" | translate }}</span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
